// src/hooks/useApi.js
import { useCallback } from 'react';
import api from '../services/api';  // Use the base api service
import { useAuth } from './useAuth';

export const useApi = () => {
  const { logout } = useAuth();

  const handleError = useCallback(async (error) => {
    if (error?.response?.status === 401) {
      await logout();
    }
    throw error;
  }, [logout]);

  const get = useCallback(async (url, config = {}) => {
    try {
      const response = await api.get(url, config);
      return response;
    } catch (error) {
      return handleError(error);
    }
  }, [handleError]);

  const post = useCallback(async (url, data = {}, config = {}) => {
    try {
      const response = await api.post(url, data, config);
      return response;
    } catch (error) {
      return handleError(error);
    }
  }, [handleError]);

  const put = useCallback(async (url, data = {}, config = {}) => {
    try {
      const response = await api.put(url, data, config);
      return response;
    } catch (error) {
      return handleError(error);
    }
  }, [handleError]);

  const del = useCallback(async (url, config = {}) => {
    try {
      const response = await api.delete(url, config);
      return response;
    } catch (error) {
      return handleError(error);
    }
  }, [handleError]);

  // Add a patch method if needed
  const patch = useCallback(async (url, data = {}, config = {}) => {
    try {
      const response = await api.patch(url, data, config);
      return response;
    } catch (error) {
      return handleError(error);
    }
  }, [handleError]);

  return { 
    get, 
    post, 
    put, 
    del,
    patch
  };
};

export default useApi;